// services/userService.ts
import axios from 'axios';
import getApiBaseUrl from '../GetServer';

export interface NewUserRequest {
  UserName: string;
  Email: string;
  Password: string;
  Status: number; // 0 = inactivo, 1 = activo
  Roles: number[]; // IDs de roles
}


export const createUser = async (userData: NewUserRequest) => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/new-user`;
    const token = localStorage.getItem('token');
    
    if (!token) throw new Error('Token de autenticación no encontrado');

    const response = await axios.post(
      endpoint,
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
    
  } catch (error) {
    handleCreateUserError(error);
  }
};

// Manejo detallado de errores
const handleCreateUserError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const serverResponse = error.response?.data;
    
    // Errores estructurados del backend
    if (serverResponse && typeof serverResponse === 'object') {
      throw new Error(serverResponse.message || 'Error en creación de usuario');
    }
    
    // Errores de validación
    if (error.response?.status === 400) {
      throw new Error('Datos incompletos o inválidos');
    }
    
    // Error de autenticación
    if (error.response?.status === 401) {
      throw new Error('Sesión expirada. Vuelva a iniciar sesión');
    }
    
    // Conflictos de datos
    if (error.response?.status === 409) {
      throw new Error('El correo electrónico ya está registrado');
    }
  }
  
  // Errores genéricos
  throw new Error('Error de conexión con el servidor');
};